var _effectorFileName = "/src/shared/api/send-message/api.ts";
import { withFactory as _withFactory } from "effector";
import { createMutation } from '@farfetched/core';
import { createEffect } from 'effector';
import { ContactFormData } from '@/shared/components/contact-form/types';
import { httpClient } from '../api';
import { ContactFormResponse } from './types';
const URL = process.env.NODE_ENV === 'development' ? 'http://localhost:3000' : process.env.NEXT_PUBLIC_APP_URL;
export const postContactFormFx = createEffect(async (formData: ContactFormData) => {
  const contactFormResponse = await httpClient<ContactFormResponse>(`${URL}/api/send-message`, {
    method: 'POST',
    body: JSON.stringify(formData)
  });
  return contactFormResponse;
}, {
  loc: {
    file: _effectorFileName,
    line: 11,
    column: 33
  },
  name: "postContactFormFx",
  sid: "-isb51f"
});
export const postContactFormMutation = _withFactory({
  sid: "-knsz8e",
  fn: () => createMutation({
    handler: postContactFormFx
  }),
  name: "postContactFormMutation",
  method: "createMutation",
  loc: {
    file: _effectorFileName,
    line: 20,
    column: 39
  }
});